/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EChannelScopeType } from "../types/EChannelScopeType.ts";

/**
 * @description 1 = Course | 2 = ClassStudent | 3 = ClassroomDiscipline |
 */
export const eChannelScopeTypeSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Course | 2 = ClassStudent | 3 = ClassroomDiscipline | ",
  ) as unknown as ToZod<EChannelScopeType>;
